import { signalStore, withState } from '@ngrx/signals';
import { Direction } from '../../enum';
import { ValidationRule } from '../../model';
import { ValidationRuleService } from '../../services';
import { initialState, withCommonMethods, withCrudMethods } from '../../state';

const initState = initialState<ValidationRule>({ direction: Direction.ASC });
export const ValidationRulesStore = signalStore(
  withState(initState),
  withCrudMethods(ValidationRuleService),
  withCommonMethods()
);
